<div class="container-fluid wrapper-page">
  <div align="center">
    <h4 class="mt-2 mb-2">EDIT PROFILE - DOCTOR</h4>
  </div>
  <div class="page-head">
    <h5><a href="javascript:void(0)"><i class="fa fa-arrow-circle-left" (click)="getback()"> BACK
        </i></a>
    </h5>
  </div>
  <!-- <form #editDoctorForm="ngForm" enctype="multipart/form-data" [formGroup]="forms['personalInformation']"> -->
  <div class="row w-100">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <div align="right" class="font-italic text-danger  font-size-14  text-right">
            Note *
            are Mandatory
          </div>
          <ul class="tablist">
            <li role="tab"><a class="nav-link" (click)="editDoctorAssignTab('personalInformation')"
                [ngClass]="{'active':editDoctorCurrentTab == 'personalInformation'}" href="javascript:void(0)"
                role="tab"><span class="number">1.</span>Personal Information</a></li>
            <li role="tab"><a href="javascript:void(0)" (click)="editDoctorAssignTab('professionalInformation')"
                [ngClass]="{'active':editDoctorCurrentTab == 'professionalInformation'}" class="nav-link"><span
                  class="number">2.</span>Professional Information</a></li>
            <li role="tab" *ngIf="checkIfDoctor()"><a href="javascript:void(0)"
                (click)="editDoctorAssignTab('bankAccount')"
                [ngClass]="{'active':editDoctorCurrentTab == 'bankAccount'}" class="nav-link"><span
                  class="number">3.</span>Bank Account</a></li>
          </ul>
          <form #editDoctorForm="ngForm" enctype="multipart/form-data" [formGroup]="forms['personalInformation']">
            <!----========   PERSONAL INFORMATION =========================  -->
            <ng-container *ngIf="editDoctorCurrentTab=='personalInformation'">
              <section class="mt-3 ml-2 align-items-center">
                <div class="form-group row mb30">
                  <div class="col-md-1">
                  </div>
                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="avaitarImg">
                          <!-- <img src="assets/new-ui/images/users/avatar.jpg" style="height: 180px; border-radius: 10px;"
                            class=""> -->
                          <label class="hoverable" for="imgUrl">

                            <img [src]="physician && physician?.ppurl ? physician?.ppurl : ''">
                            <div class="hover-text">Edit</div>
                            <div class="background"></div>

                            <!-- <div *ngIf="avatartimg != 'default_doctor.png'">
                              <img [src]="physician && physician?.ppurl ? physician?.ppurl : ''">
                              <div class="hover-text">Edit</div>
                              <div class="background"></div>
                            </div>

                            <div class="profileImage" *ngIf="avatartimg == 'default_doctor.png'">
                              <avatar text={{physicianname}} hash={{user?.name}}></avatar>
                              <div class="hover-text">Edit</div>
                              <div class="background"></div>
                            </div> -->


                          </label>
                          <br>
                          <input id="imgUrl" type='file' accept=".png, .jpg, .jpeg" (change)="fileSelected($event)">
                        </div>
                      </div>
                      <div class="col-md-8">
                        <h5 class="innerheading">Personal Information</h5>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>Title</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <p>
                              <editable (update)="updateField('title')">
                                <ng-template viewMode>
                                  {{physician && physician?.title ? getTitle(physician?.title) : "Enter Title"}}
                                </ng-template>
                                <ng-template editMode>
                                  <select class="form-control" [formControl]="getControl('title')"
                                    formControlName="title" focusable>
                                    <option *ngFor="let x of title" [value]="x?.key">{{x?.value}}</option>
                                  </select>
                                </ng-template>
                              </editable>
                            </p>
                          </div>
                        </div>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>First Name</label>
                          </div>
                          <div class="col-6 col-md-8" *ngIf="physician && physician?.first_name">
                            {{physician?.first_name}}
                          </div>
                        </div>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>Last Name</label>
                          </div>

                          <div class="col-6 col-md-8" *ngIf="physician && physician.last_name">
                            {{physician.last_name}}
                          </div>
                        </div>
                        <div class="row mb10">
                          <div class="col-6 col-md-4 mt-2">
                            <label for="name">Date of Birth<span class="text-danger "> * </span></label>
                          </div>

                          <div class="d-flex col-6 col-md-4 row">
                            <div class="d-flex ">
                              <input class="form-control" placeholder="End Date(DD/MM/YYYY)" name="dob"
                                formControlName="dob" ngbDatepicker #ed="ngbDatepicker" data-date-inline-picker="false"
                                [minDate]="miniDate" [maxDate]="currentDate" id="dob" disabled />
                              <div>
                                <button class="btn btn-outline-secondary calendar rounded-0" (click)="ed.toggle()"
                                  type="button" style="line-height: 2.5;" id="endDateButton">
                                  <span class="fa fa-calendar"></span>
                                </button>
                              </div>
                            </div>
                            <div
                              *ngIf="getControl('dob').hasError('required') && !(getControl('dob').hasError('matDatepickerMax') || getControl('dob').hasError('matDatepickerMin') || getControl('dob').hasError('matDatepickerParse'))">
                              <label class="text-danger ">DOB is required</label>
                            </div>
                            <div class="text-danger "
                              *ngIf="getControl('dob').hasError('matDatepickerMax') || getControl('dob').hasError('matDatepickerMin')">
                              <label class="text-danger">DOB is invalid</label>
                            </div>
                            <!-- <mat-form-field class="border-top-0">
                              <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                                formControlName="dob" [formControl]="getControl('dob')" readonly required>
                              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>

                              <mat-error *ngIf="getControl('dob')">
                                <div *ngIf="getControl('dob').errors" class="invalid-feedback">Invalid DOB.
                                </div>

                                <div
                                  *ngIf="getControl('dob').hasError('required') && !(getControl('dob').hasError('matDatepickerMax') || getControl('dob').hasError('matDatepickerMin') || getControl('dob').hasError('matDatepickerParse'))">
                                  DOB is required</div>
                                <div
                                  *ngIf="getControl('dob').hasError('matDatepickerMax') || getControl('dob').hasError('matDatepickerMin')">
                                  DOB is invalid</div>
                              </mat-error>
                            </mat-form-field> -->
                          </div>
                        </div>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>Qualification<span class="text-danger "> * </span></label>
                          </div>

                          <div class="d-flex col-6 col-md-4 row">
                            <editable (update)="updateField('qualification')">
                              <ng-template viewMode>
                                {{ physician && physician?.qualification ? physician?.qualification :
                                "Enter Qualification" }}
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" [formControl]="getControl('qualification')"
                                  formControlName="qualification" focusable>
                              </ng-template>
                            </editable>
                            <div *ngIf="getControl('qualification').hasError('required')">
                              <label class="text-danger"> Qualification is required</label>
                            </div>
                          </div>
                        </div>

                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>Registration Number <span class="text-danger "> * </span></label>
                          </div>
                          <div class="col-6 col-md-4">
                            <editable (update)="updateField('r_no')">

                              <ng-template viewMode>
                                {{physician && physician?.r_no ? physician?.r_no : "Enter Registration Number"}}
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" [formControl]="getControl('r_no')" formControlName="r_no"
                                  focusable>
                              </ng-template>
                            </editable>
                            <div *ngIf="getControl('r_no').hasError('required')">
                              <label class="text-danger"> Registration No is required</label>
                            </div>
                          </div>

                        </div>

                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>State Medical Council<span class="text-danger "> * </span></label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('smc')">
                              <ng-template viewMode>
                                {{physician && physician?.smc ? getSmcName(physician?.smc) : "Enter SMC"}}
                              </ng-template>
                              <ng-template editMode>
                                <select class="form-control" [formControl]="getControl('smc')" formControlName="smc"
                                  focusable>
                                  <option *ngFor="let x of smcs" [value]="x?.id">{{x?.name}}</option>
                                </select>
                              </ng-template>
                            </editable>
                            <div *ngIf="getControl('smc').hasError('required')">
                              <label class="text-danger"> State Medical Council Name is required</label>
                            </div>
                          </div>
                        </div>


                      </div>

                    </div>
                  </div>
                  <div class="col-md-1">
                  </div>
                </div>
                <br>
                <div class="form-group row">
                  <div class="col-md-1">
                  </div>
                  <div class="col-md-10">
                    <div class="row mb10">

                      <div class="col-md-6">
                        <h5 class="innerheading">CONTACT DETAILS</h5>
                        <div class="row">
                          <div class="col-6 col-md-4">
                            <label>Address</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <p>
                              <editable (update)="updateField('address_1')">

                                <ng-template viewMode>
                                  {{physician && physician?.address_1 ? physician?.address_1 : "Enter address"}}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('address_1')"
                                    formControlName="address_1" focusable>
                                </ng-template>
                              </editable>
                            </p>
                            <p>
                              <editable (update)="updateField('address_2')">

                                <ng-template viewMode>
                                  {{physician && physician?.address_2 ? physician?.address_2: "Enter address"}}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('address_2')"
                                    formControlName="address_2" focusable>
                                </ng-template>
                              </editable>
                            </p>
                            <p>
                              <editable (update)="updateField('city')">
                                <ng-template viewMode>
                                  {{physician && physician?.city ? physician?.city : "Enter City"}}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('city')" formControlName="city"
                                    focusable>
                                </ng-template>
                              </editable>
                            </p>

                            <p>
                              <editable (update)="updateField('state')">
                                <ng-template viewMode>
                                  {{physician && physician?.state ? getStateName(physician?.state) : "Enter State"}}
                                </ng-template>
                                <ng-template editMode>
                                  <select class="form-control" [formControl]="getControl('state')"
                                    formControlName="state" focusable>
                                    <option *ngFor="let x of states" [value]="x?.id">{{x?.name}}</option>
                                  </select>
                                </ng-template>
                              </editable>
                            </p>

                            <p>
                              <editable (update)="updateField('zip')">
                                <ng-template viewMode>
                                  {{physician && physician?.zip ? (physician?.zip) : "Enter ZipCode"}}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" [formControl]="getControl('zip')" formControlName="zip"
                                    focusable>
                                </ng-template>
                              </editable>
                              <span *ngIf="getControl('zip').errors" class="invalid-feedback">Invalid Zip Code.
                              </span>
                              <span *ngIf="getControl('zip').errors && getControl('zip').errors.required"
                                class="invalid-feedback">Zip is required</span>
                            </p>


                          </div>
                        </div>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>Contact</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('contact_no')">

                              <ng-template viewMode>
                                {{physician && physician?.contact_no ? physician?.contact_no : "Enter Contact Number"}}
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" [formControl]="getControl('contact_no')" focusable
                                  maxlength="12" minlength="10">

                              </ng-template>
                            </editable>
                            <span *ngIf="getControl('contact_no').errors" class="invalid-feedback">Invalid
                              Contact Number.</span>
                            <span *ngIf="getControl('contact_no').errors && getControl('contact_no').errors.required"
                              class="invalid-feedback">This is
                              required</span>
                          </div>
                        </div>
                        <div class="row" mb10>
                          <div class="col-6 col-md-4">
                            <label>Email</label>
                          </div>

                          <div class="col-6 col-md-8" *ngIf="physician && physician?.email_id">
                            {{physician?.email_id}}
                          </div>
                        </div>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>Public-Contact</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('contact_no2')">

                              <ng-template viewMode>
                                {{physician && physician?.contact_no2 ? physician?.contact_no2 :
                                "Enter Public Contact Number"}}
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" [formControl]="getControl('contact_no2')" focusable
                                  maxlength="10" minlength="10">
                              </ng-template>
                            </editable>
                            <span *ngIf="getControl('contact_no2').errors" class="invalid-feedback">Invalid
                              Public Contact Number.</span>
                          </div>
                        </div>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label>Public Email</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('email_id2')">

                              <ng-template viewMode>
                                {{physician && physician?.email_id2 ? physician?.email_id2 : "Enter Public Email"}}
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" [formControl]="getControl('email_id2')" focusable>

                              </ng-template>
                            </editable>
                            <span *ngIf="getControl('email_id2').errors" class="invalid-feedback">Invalid
                              email.</span>

                          </div>
                        </div>


                      </div>
                      <div class="col-md-6">
                        <h5 class="innerheading">FEES STRUCTURE</h5>

                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label class="text-capitalize">Consulting Fees</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('fee')">
                              <ng-template viewMode>
                                {{physician && physician?.fee ? " Rs." + physician?.fee : "Rs. 0"}}
                              </ng-template>
                              <ng-template editMode>
                                <input type=number min="0" class="form-control" [formControl]="getControl('fee')"
                                  focusable>
                              </ng-template>
                            </editable>
                          </div>

                        </div>

                        <div class="row" mb10>
                          <div class="col-6 col-md-4">
                            <label class="text-capitalize">Consultation Fees applied to patient </label>
                          </div>

                          <div class="col-6 col-md-8" *ngIf="physician && physician.fee_patient>=0">
                            Rs. {{physician.fee_patient}} </div>
                        </div>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label class="text-capitalize">Follow up Fees</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('followup_fee')">
                              <ng-template viewMode>
                                {{physician && physician?.followup_fee ? " Rs." + physician?.followup_fee : "Rs. 0"}}
                              </ng-template>
                              <ng-template editMode>
                                <input type=number min="0" class="form-control"
                                  [formControl]="getControl('followup_fee')" focusable>
                              </ng-template>
                            </editable>
                          </div>
                        </div>
                        <div class="row" mb10>
                          <div class="col-6 col-md-4">
                            <label class="text-capitalize">Follow up Fees applied to patient</label>
                          </div>

                          <div class="col-6 col-md-8" *ngIf="physician && physician.followup_fee_patient>=0">
                            Rs. {{physician?.followup_fee_patient}} </div>

                        </div>
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label class="text-capitalize">Follow up days</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('followup_days')">

                              <ng-template viewMode>
                                {{physician && physician?.followup_days ? physician?.followup_days + " days" :
                                defaultDays + " days"}}
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" [formControl]="getControl('followup_days')" focusable>
                              </ng-template>
                            </editable>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="col-md-1">
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-1">
                  </div>
                  <div class="col-md-10">
                    <div class="row mb10">

                      <div class="col-md-6 ">
                        <h5 class="innerheading">ADDITIONAL INFORMATION</h5>
                        <div class="row mb10 addinfo">
                          <div class="col-12 col-md-12">
                            <editable (update)="updateField('additional_info')">

                              <ng-template viewMode>
                                {{physician && physician?.additional_info ? physician?.additional_info : "Additional
                                Information"}}
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" [formControl]="getControl('additional_info')" focusable>
                              </ng-template>
                            </editable>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 ">
                        <h5 class="innerheading"> APPOINTMENTS PREFERENCE</h5>
                        <!-- 
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label class="text-capitalize">Allow booking</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('AppointmentDays')">
                              <ng-template viewMode>
                                {{physician && physician?.aptinterval ? physician?.aptinterval : "0"}}
                                days in advance
                              </ng-template>
                              <ng-template editMode>
                                <input type=number min="0" class="form-control" formcontrolname="AppointmentDays"
                                  [formControl]="getControl('AppointmentDays')" focusable> days in advance
                              </ng-template>
                            </editable>
                          </div>
                        </div>

                        
                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label class="text-capitalize">Allow booking</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('appointmentDays')">
                              <ng-template viewMode>
                                {{physician && physician?.aptinterval ?
                                physician?.aptinterval : "0"}}
                              </ng-template>
                              <ng-template editMode>
                                <select class="form-control" formcontrolname="appointmentDays"
                                  [formControl]="getControl('AppointmentDays')" focusable>
                                  <option *ngFor="let x of AppointmentDays" [value]="x?.id">{{x?.Days}}</option>
                                </select>
                              </ng-template>
                            </editable> days in advance
                          </div>
                        </div>
                        <input class="form-control" [formControl]="getControl('AppointmentDays')" focusable>

                       
                      -->

                        <div class="row mb10">
                          <div class="col-6 col-md-4">
                            <label class="text-capitalize">Allow Booking</label>
                          </div>
                          <div class="col-6 col-md-8">
                            <editable (update)="updateField('AppointmentDays')">

                              <ng-template viewMode>
                                {{physician && physician?.AppointmentDays ? physician?.AppointmentDays + " days in
                                advance" :
                                physician?.aptinterval + " days in advance"}}
                              </ng-template>
                              <ng-template editMode>
                                <select class="form-control" formcontrolname="appointmentDays"
                                  [formControl]="getControl('AppointmentDays')" focusable>
                                  <option *ngFor="let x of AppointmentDays" [value]="x?.id">{{x?.Days}}</option>
                                </select>

                              </ng-template>
                            </editable>
                          </div>
                        </div>










                      </div>
                    </div>
                  </div>
                  <div class="col-md-1">
                  </div>
                </div>
              </section>
            </ng-container>
          </form>
          <!----========  PROFESSIONAL INFORMATION =========================  -->
          <form #editDoctorForm="ngForm" [formGroup]="forms['professionalInformation']">
            <ng-container *ngIf="editDoctorCurrentTab=='professionalInformation'">
              <section class="mt-3 ml-2">
                <div class="form-group row">
                  <div class="col-md-1">
                  </div>
                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-12">
                        <h5 class="innerheading">SPECIALITY <i class="fa fa-plus closebuttonblue"
                            (click)="addNewFormArray('physician_speciality')"></i>
                        </h5>
                        <div class="row mb10 pt-2" formArrayName="physician_speciality"
                          *ngFor="let item of getControls('physician_speciality')['controls']; let i = index;">

                          <div class="col-6 col-md-6" [formGroupName]="i">
                            <editable (update)="updateField('physician_speciality')">
                              <ng-template viewMode>
                                {{showFormArrayVal(i, 'physician_speciality', 'speciality_id')}} <span
                                  class="text-danger "> * </span>
                              </ng-template>
                              <ng-template editMode>
                                <select class="form-control" name="expertise" formControlName="speciality_id">
                                  <option *ngFor="let x of specialitiesList" [value]="x.id">{{x.name}}</option>
                                </select>
                              </ng-template>
                            </editable>

                            <div *ngIf="formValidation(i, 'speciality_id', 'physician_speciality')"
                              class="invalid-feedback">Required</div>
                          </div>
                          <div class="col-6 col-md-6" [formGroupName]="i">
                            <editable (update)="updateField('physician_speciality')">
                              <ng-template viewMode>
                                {{showFormArrayVal(i, 'physician_speciality', 'no_of_years')}} years <span
                                  class="text-danger "> * </span>
                              </ng-template>
                              <ng-template editMode>
                                <input type="number" max="100" min="1" class="form-control"
                                  formControlName="no_of_years" focusable>
                              </ng-template>
                            </editable>
                            <i class="fa fa-close closebutton mr-0"
                              (click)="removeFromList('physician_speciality', i)"></i>

                            <div *ngIf="formValidation(i, 'no_of_years', 'physician_speciality')"
                              class="invalid-feedback">
                              Required</div>
                          </div>
                          <!-- <div class="col-md-4">

                          </div> -->

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1">
                  </div>
                </div>
                <br>
                <div class="form-group row">
                  <div class="col-md-1">
                  </div>
                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-12 addinfowrp">

                        <h5 class="innerheading">EDUCATION <i class="fa fa-plus closebuttonblue"
                            (click)="addNewFormArray('physician_education')"></i></h5>
                        <div class="row" formArrayName="physician_education"
                          *ngFor="let item of getControls('physician_education')['controls']; let i = index;">
                          <div class="col-6 col-md-3  pt-2" [formGroupName]="i">
                            <div>
                              <editable (update)="updateField('physician_education')">
                                <ng-template viewMode>
                                  {{showFormArrayVal(i, 'physician_education', 'degree')}} <span class="text-danger "> *
                                  </span>
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" formControlName="degree" focusable>
                                </ng-template>
                              </editable>

                              <div *ngIf="formValidation(i, 'degree', 'physician_education')" class="invalid-feedback">
                                Required</div>
                            </div>
                          </div>
                          <div class="col-6 col-md-3" [formGroupName]="i">
                            <editable (update)="updateField('physician_education')">
                              <ng-template viewMode>
                                {{showFormArrayVal(i, 'physician_education', 'institution')}} <span
                                  class="text-danger "> * </span>
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" formControlName="institution" focusable>
                              </ng-template>
                            </editable>
                            <div *ngIf="formValidation(i, 'institution', 'physician_education')"
                              class="invalid-feedback">
                              Required</div>
                          </div>
                          <div class=" col-6 col-md-3" [formGroupName]="i">
                            <div>
                              <editable (update)="updateField('physician_education')">
                                <ng-template viewMode>

                                  {{showFormArrayVal(i, 'physician_education', 'from_year')}}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" formControlName="from_year" focusable>
                                </ng-template>
                              </editable>
                              <div *ngIf="formValidation(i, 'from_year', 'physician_education')"
                                class="invalid-feedback">
                                Required</div>-
                              <editable (update)="updateField('physician_education')">
                                <ng-template viewMode>
                                  {{showFormArrayVal(i, 'physician_education', 'to_year')}}
                                </ng-template>
                                <ng-template editMode>
                                  <input class="form-control" formControlName="to_year" focusable>
                                </ng-template>
                              </editable>
                              <div *ngIf="formValidation(i, 'to_year', 'physician_education')" class="invalid-feedback">
                                Required</div>

                            </div>
                          </div>
                          <div class="col-6 col-md-3" [formGroupName]="i">
                            <editable (update)="updateField('physician_education')">
                              <ng-template viewMode>
                                {{ showFormArrayVal(i, 'physician_education', 'country')}}
                              </ng-template>
                              <ng-template editMode>
                                <select class="form-control" name="country" formControlName="country">
                                  <option value="No Country">Country</option>
                                  <option *ngFor="let x of countries" [value]="x.id">{{x.code}} - {{x.name}}</option>
                                </select>
                              </ng-template>
                            </editable>
                            <i class="fa fa-close closebutton mr-0"
                              (click)="removeFromList('physician_education', i)"></i>
                            <div *ngIf="formValidation(i, 'country', 'physician_education')" class="invalid-feedback">
                              Required</div>

                          </div>
                        </div>
                        <div class="row mb10"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <br>
                <div class="form-group row">
                  <div class="col-md-1">
                  </div>
                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-12">
                        <h5 class="innerheading">WORK EXPERIENCE <i class="fa fa-plus closebuttonblue"
                            (click)="addNewFormArray('physician_experience')"></i></h5>
                        <div class="row mb10" formArrayName="physician_experience"
                          *ngFor="let item of getControls('physician_experience')['controls']; let i = index;">


                          <div class="col-6 col-md-3  pt-2" [formGroupName]="i">
                            <editable (update)="updateField('physician_experience')">
                              <ng-template viewMode>
                                {{showFormArrayVal(i, 'physician_experience', 'designation')}} <span
                                  class="text-danger "> * </span>
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" formControlName="designation" focusable>
                              </ng-template>
                            </editable>

                            <div *ngIf="formValidation(i, 'designation', 'physician_experience')"
                              class="invalid-feedback">
                              Required</div>

                          </div>
                          <div class="col-6 col-md-3" [formGroupName]="i">
                            <editable (update)="updateField('physician_experience')">
                              <ng-template viewMode>
                                {{showFormArrayVal(i, 'physician_experience', 'employer')}} <span class="text-danger ">
                                  * </span>
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" formControlName="employer" focusable>
                              </ng-template>
                            </editable>

                            <div *ngIf="formValidation(i, 'employer', 'physician_experience')" class="invalid-feedback">
                              Required</div>
                          </div>
                          <div class="col-6 col-md-3" [formGroupName]="i">
                            <editable (update)="updateField('physician_experience')">
                              <ng-template viewMode>
                                {{showFormArrayVal(i, 'physician_experience', 'from_year')}}
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" formControlName="from_year" focusable>
                              </ng-template>

                            </editable>
                            <div *ngIf="formValidation(i, 'from_year', 'physician_experience')"
                              class="invalid-feedback">
                              Required</div>-
                            <editable (update)="updateField('physician_experience')">
                              <ng-template viewMode>
                                {{showFormArrayVal(i, 'physician_experience', 'to_year')}}
                              </ng-template>
                              <ng-template editMode>
                                <input class="form-control" formControlName="to_year" focusable>
                              </ng-template>
                            </editable>

                            <div *ngIf="formValidation(i, 'to_year', 'physician_experience')" class="invalid-feedback">
                              Required</div>
                          </div>
                          <div class="col-6 col-md-3" [formGroupName]="i">
                            <editable (update)="updateField('physician_experience')">
                              <ng-template viewMode>
                                {{showFormArrayVal(i, 'physician_experience', 'country')}}
                              </ng-template>
                              <ng-template editMode>
                                <select class="form-control" name="country" formControlName="country">
                                  <option value="No Country">Country</option>
                                  <option *ngFor="let x of countries" [value]="x.id">{{x.code}} - {{x.name}}</option>
                                </select>
                              </ng-template>
                            </editable>
                            <i class="fa fa-close closebutton mr-0"
                              (click)="removeFromList('physician_experience', i)"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1">
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-1">
                  </div>
                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-12">
                        <h5 class="innerheading">ILLNESS TREATED
                          <span class="mdi mdi-information" style="color:#2E61F2;" data-toggle="tooltip"
                            data-placement="top"
                            title="Please select the Illnesses treated by you, This helps us in recommending your profile to patients looking to find a doctor online.">
                          </span>
                        </h5>
                        <!-- <span (mouseenter)="mouseEnter() " (mouseleave)="mouseLeave()" class="mdi mdi-close-circle"></span> -->



                        <angular2-multiselect class="form-control" formControlName="illness" [data]="illness_list"
                          [(ngModel)]="selectedItems" [settings]="dropdownSettings" (onSelect)="onItemSelect($event)"
                          (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)"
                          (onDeSelectAll)="onDeSelectAll($event)">
                        </angular2-multiselect>

                      </div>
                    </div>
                  </div>
                  <div class="col-md-1">
                  </div>
                </div>

              </section>
            </ng-container>


          </form>


          <!----======== BANK ACCOUNT=========================  -->
          <form #editDoctorForm="ngForm" [formGroup]="forms['bankAccount']" *ngIf="checkIfDoctor()">
            <ng-container *ngIf="editDoctorCurrentTab=='bankAccount'">
              <section class="mt-3 ml-2 align-items-center">
                <div class="form-group row mb30">
                  <label class="col-lg-2 col-form-label">Beneficiary Name <span class="text-danger "> * </span></label>
                  <div class="col-lg-4">
                    <input type="text" class="form-control" formControlName="beneficiary_name" required>
                    <div *ngIf="forms['bankAccount'].get('beneficiary_name').hasError('required')"
                      class="invalid-feedback">
                      Beneficiary Name is <strong>required</strong>.</div>
                    <div *ngIf="forms['bankAccount'].get('beneficiary_name').hasError('pattern')"
                      class="invalid-feedback">
                      Beneficiary Name is <strong>invalid</strong>.</div>
                  </div>

                  <label class="col-lg-2 col-form-label">Account Number <span class="text-danger "> * </span></label>
                  <div class="col-lg-4">
                    <input type="text" class="form-control" formControlName="account_number" required>
                    <div *ngIf="forms['bankAccount'].get('account_number').hasError('required')"
                      class="invalid-feedback">
                      Account Number is <strong>required</strong>.</div>
                    <div *ngIf="forms['bankAccount'].get('account_number').hasError('pattern')"
                      class="invalid-feedback">
                      Account Number is <strong>invalid</strong>.</div>
                  </div>

                  <label class="col-lg-2 col-form-label" *ngIf="!physician?.physician_bank_details">Confirm Account
                    Number <span class="text-danger "> * </span></label>
                  <div class="col-lg-4" *ngIf="!physician.physician_bank_details">
                    <input type="text" class="form-control" formControlName="confirm_account_number" required>
                    <div *ngIf="forms['bankAccount'].get('confirm_account_number').hasError('required')"
                      class="invalid-feedback">
                      Confirm Account Number is <strong>required</strong>.</div>
                    <div *ngIf="forms['bankAccount'].get('confirm_account_number').hasError('pattern')  "
                      class="invalid-feedback">
                      Confirm Account Number <strong>is invalid</strong>.</div>
                    <div *ngIf="forms['bankAccount'].get('confirm_account_number').hasError('confirmedValidator')  "
                      class="invalid-feedback">
                      Account number and Confirm Account Number <strong>do not match</strong>.</div>
                  </div>

                  <label class="col-lg-2 col-form-label">IFSC Code <span class="text-danger "> * </span></label>
                  <div class="col-lg-4">
                    <input type="text" class="form-control" formControlName="ifsc_code" required>
                    <div *ngIf="forms['bankAccount'].get('ifsc_code').hasError('required')" class="invalid-feedback">
                      IFSC Code is <strong>required</strong>.</div>
                    <div *ngIf="forms['bankAccount'].get('ifsc_code').hasError('pattern')" class="invalid-feedback">
                      IFSC Code is <strong>invalid</strong>.</div>
                  </div>

                  <label class="col-lg-2 col-form-label">AccountType <span class="text-danger "> *
                    </span></label>

                  <!-- <div class="col-lg-4">
                    <input type="text" class="form-control" formControlName="account_type" required>
                    <div *ngIf="forms['bankAccount'].get('account_type').hasError('required')" class="invalid-feedback">
                      Account Type is <strong>required</strong>.</div>
                    <div *ngIf="forms['bankAccount'].get('account_type').hasError('pattern')" class="invalid-feedback">
                      Account Type is <strong>invalid</strong>.</div>
                  </div> -->

                  <div class="col-lg-4" *ngIf="!physician?.physician_bank_details">

                    <select class="selectpicker form-control" formControlName="account_type" required>
                      <option *ngFor="let accType of phyBankAccType" [ngValue]="accType">
                        {{ accType }}
                      </option>
                    </select>

                    <div *ngIf="forms['bankAccount'].get('account_type').hasError('required')" class="invalid-feedback">
                      Account Type is <strong>required</strong>.</div>
                    <div *ngIf="forms['bankAccount'].get('account_type').hasError('pattern')" class="invalid-feedback">
                      Account Type is <strong>invalid</strong>.</div>
                  </div>

                  <div class="col-lg-4" *ngIf="physician?.physician_bank_details">
                    <input type="text" class="form-control" formControlName="account_type"
                      value=" {{this.physician.physician_bank_details.account_type}}">
                  </div>
                </div>
                <div class="form-group row mb30">
                  <div class="col-lg-12">
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" id="terms" [(ngModel)]="termsConditions"
                        [ngModelOptions]="{standalone: true}" [disabled]="physician?.physician_bank_details">
                      <label class="form-check-label" for="terms">I accept terms and conditions.
                        <span class="invalid-feedback" *ngIf="!termsConditions">* required</span> </label>
                    </div>
                  </div>
                </div>
                <br>
                <div class="row mb30">
                  <div class="col-lg-12">
                    <p class="alert alert-danger"><em><strong>Note:</strong> Above information cannot be modified after
                        submit. Please enter the
                        correct details</em>
                    </p>
                  </div>
                </div>
              </section>
            </ng-container>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- Profile Vertfy checkbox (Enhancement) -->
  <!-- <div class="form-check">
    <input type="checkbox" class="form-check-input" id="terms">
    <label class="form-check-label text-primary h5" for="terms">I Verified my Profile.
      <span class="invalid-feedback" *ngIf="!termsConditions">* required</span> </label>
  </div> -->

  <div class="row float-right mb-5">
    <div class="col-lg-12">
      <button type="button" class="btn btn-primary btn-patient mr-3"
        *ngIf="editDoctorCurrentTab != 'personalInformation'" (click)="doctorEditPreviousTab()">Previous</button>

      <button type="button" class="btn btn-primary btn-patient mr-5 mr-md-4"
        *ngIf="editDoctorCurrentTab == 'professionalInformation' || editDoctorCurrentTab == 'personalInformation'"
        [disabled]="forms['personalInformation'].invalid || forms['professionalInformation'].invalid"
        (click)="editProfile()">Save</button>

      <button type="button" class="btn btn-primary btn-patient mr-5 mr-md-4"
        *ngIf="editDoctorCurrentTab == 'personalInformation' ; else elseBlock"
        (click)="doctorEditNextTab()">Next</button>

      <ng-template #elseBlock>
        <button type="button" class="btn btn-primary btn-patient mr-5 mr-md-4"
          *ngIf="editDoctorCurrentTab != 'bankAccount' && checkIfDoctor()" (click)="doctorEditNextTab()">Next</button>
      </ng-template>


      <button type="button" class="btn btn-primary btn-patient mr-5 mr-md-4"
        *ngIf="editDoctorCurrentTab == 'bankAccount'"
        [disabled]="forms['bankAccount'].invalid || !termsConditions || physician?.physician_bank_details"
        (click)="editProfile()">Save</button>



      <button type="button" class="btn btn-primary btn-patient mr-5 mr-md-4"
        *ngIf="editDoctorCurrentTab == 'bankAccount'"
        [disabled]="forms['bankAccount'].invalid || forms['personalInformation'].invalid || forms['professionalInformation'].invalid || !termsConditions"
        (click)="saveProfile()">Save All</button>

    </div>
  </div>
  <!-- </form> -->
</div>